'use strict'

import { getPackageModeOfSale, getSourceNumber } from '../utils/cookies';
import { publicGet } from '../utils/m2';

let cache = {}

export function getPackages(modeOfSale, source) {
    modeOfSale = modeOfSale || getPackageModeOfSale();
    source = source || getSourceNumber();

    const stage = window.AppConfig.stage.toLowerCase();

    const key = `${stage}-${modeOfSale}-${source}`;

    if (key in cache) {
        return cache[key];
    }

    const params = {
        urlParams: {
            modeOfSale,
            source,
            stage,
        },
    }

    cache[key] = publicGet('package-feed/{modeOfSale}/{source}/{stage}', params).then(response => {
        return response.data.map(item => {
            item.TicketLink = null;

            if (item.CustomBookingLink) {
                item.TicketLink = item.CustomBookingLink;
            } else if (item.IsFlexSeatPackage) {
                item.TicketLink = `${window.AppConfig.flexPackageBookingBaseUrl}/${item.PackageNumber}`;
            } else {
                item.TicketLink = `${window.AppConfig.fixedPackageBookingBaseUrl}/${item.PackageNumber}`;
            }

            return item;
        });
    }).catch(error => {
        console.error(error);
        return [];
    });

    return cache[key];
}

export function getPackage(packageNumber) {
    return getPackages().then(response => {
        return response.find(item => {
            return parseInt(item.PackageNumber, 10) === parseInt(packageNumber, 10);
        })
    }).catch(error => {
        console.error(error);
        return null;
    });
}
